import { DrawerBase } from './DrawerBase';
import { GAME_SCENE } from '../constats';

export class BaseComponentDrawer extends DrawerBase {
  execute({ scene }) {
    switch (scene) {
      case GAME_SCENE.MAIN:
        return this.executeMainScene();
      case GAME_SCENE.PRE_BONUS:
        return this.executePreBonusScene();
      case GAME_SCENE.BONUS:
        return this.executeBonusScene();
      default:
        console.error(`Unhandled scene in ${this.constructor.name}`);
        return null;
    }
  }

  executePreBonusScene() {
    throw new Error(`Implement executePreBonusScene for ${this.constructor.name}`);
  }

  executeMainScene() {
    throw new Error(`Implement executeMainScene for ${this.constructor.name}`);
  }

  executeBonusScene() {
    throw new Error(`Implement executeBonusScene for ${this.constructor.name}`);
  }

  defineContainer(container) {
    this.container = container;
  }

  onLoad() {
    throw new Error(`Implement onLoad for ${this.constructor.name}`);
  }
}
